import { DDNSchema, E164Schema } from "cadendar-shared";

import type { LocalNewPatient } from "../components/FamilleGridPanel.tsx";

export function convertLocalNewPatientToNewPatient(patient: LocalNewPatient) {
  const e164 = E164Schema.safeParse(patient.portablee164);

  return {
    name: patient.name,
    forename: patient.forename,
    portablee164: e164.success ? e164.data : null,
    birthdate: DDNSchema.parse(patient.birthdate),
    email: patient.email,
    email_consent: patient.email_consent,
    sms_consent: patient.sms_consent,
    famille_id: patient.famille_id || null,
    patient_flags: null,
    adr_id: null,
    adr_flag: null,
    adr_other_text: null,
    comments: "",
    seen: null,
    former_patient: false,
    raf: null,
  };
}
